// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "545") return "vendors.c63989c9bd5be5cf.js";
  // return url for filenames based on template
  return "" + chunkId + ".chunk.bundle.js"
}